<template>
    <div>
        <v-card>
            <v-card-title>
                <span v-ripple @click="fetchData" style="cursor: pointer; font-size: 20px" >Grupos & Permissões</span>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    :disabled="loading"
                    append-icon="mdi-magnify"
                    label="Procurar"
                    single-line
                    clearable
                ></v-text-field>
                <form-permission :branches="branches" @permissionAction="fetchData" v-show="!loading"></form-permission>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="groups"
                :rows-per-page-items="Global.ROWS_PER_PAGE"
                rows-per-page-text="por página"
                :loading="loading"
                loading-text="A carregar Grupos..."
                no-data-text="A carregar Grupos..."
                :pagination.sync="pagination"
                hide-actions
                locale="pt-PT"
                class="elevation-0"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-right" style="min-width: 140px; padding-right: 10px;">
                        <v-icon small class="mr-2" @click="viewItem(props.item)">visibility</v-icon>
                        <v-icon small class="mr-2" @click="editItem(props.item)" :disabled="!!props.item.isAdmin">edit</v-icon>
                        <v-icon small class="mr-2" @click="askRemoveItem(props.item)" :disabled="!!props.item.isAdmin">block</v-icon>
                        <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete_forever</v-icon>-->
                    </td>
                </template>
                <template v-slot:footer>
                    <td :colspan="headers.length">
                        <custom-pagination
                            :totalData="totalData"
                            @onPaginationChange="paginationChangeCallBack($event)"
                            :disabled="loading"
                        ></custom-pagination>
                    </td>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import FormPermission from './GroupPermissionFormModal';
    import {eventBus} from "../../main";
    import {Global} from '../../config';
    import CustomPagination from '../extra/CustomPagination.vue';

    export default {
        name: "GroupPermission",

        data(){
            return {
                Global,
                DEFAULT_PAG_SIZE: 10,
                pagination: {},
                totalData: 0,
                sort: {},
                loading: false,
                loadingPermissionsFailed: false,
                groups: [],
                branches: [],
                totalPermissions: 0,
                search: '',
                isTyping: false,

                headers: [
                    { text: 'Grupo', align: 'left', sortable: true, value: 'name', },
                    // { text: 'Qnt. Colaboradores', align: 'center', sortable: true, value: 'users', },
                    { text: 'Ações', align: 'right', sortable: false, value: 'actions' },
                ],
            }
        },

        props: [],

        components: {
            FormPermission,
            CustomPagination,
        },

        watch: {
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
            pagination(){
                this.fetchData();
            }
        },

        methods: {

            paginationChangeCallBack(payload){
                this.consoleLog('paginationChangeCallBack');
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            fetchData(){
                if(this.loading) return;
                this.loading = true;
                this.permissions = [];
                this.loadingPermissionsFailed = false;
                this.axios.get('group', {
                    params: {
                        pag_size: this.pagination.rowsPerPage,
                        pag_current: this.pagination.page,
                        sort_field: this.getSortBy(this.pagination),
                        sort_order: this.getSortDes(this.pagination),
                        search: this.search,
                    }
                })
                .then(response => {
                    this.consoleLog('fetching permissions', response);
                    if (!response.data.success) {
                        this.handleErrorCodeMessage(response.data);
                        this.loadingPermissionsFailed = true;
                        return;
                    }

                    // this.groups = this.prepareFetchedData(response.data.response);
                    this.groups = response.data.response.groups;
                    this.consoleLog('this.groups', this.groups);
                    this.branches = response.data.response.branches;

                    this.permissions = response.data.response.permissions;
                    this.totalPermissions = response.data.response.totalPermissions;

                        this.totalData = response.data.response.total_data;

                }).catch(error => {
                    this.consoleLog(error);
                    this.loadingPermissionsFailed = true;
                    this.showSnackBar('ocorreu um erro. Tente novamente...', 'red');
                }).finally(() => {
                    this.loading = false;
                });
            },
            
            noDataText(){
                return this.loading ? 'a carregar grupos ...' : 'nenhum grupo.';
            },

            //Used to convert 'permissions' from string to json
            prepareFetchedData(fetchedGroups){
                for(let i=0; i<fetchedGroups.length; i++){
                    if(!fetchedGroups[i].permissions){
                        fetchedGroups[i].permissions = this.getPermissions();
                    }else
                        fetchedGroups[i].permissions = JSON.parse(fetchedGroups[i].permissions);
                }
                return fetchedGroups;
            },

            editItem(item){
                this.selectedPermission = item;
                this.showFormPermission = true;
            },

            viewItem(item){
                this.consoleLog('on EYE icon click:', item);
                this.selectedPermission = item;
                this.showFormPermissionViewMode = true;
                this.showFormPermission = true;
            },

            askRemoveItem(item){
                this.confirmationDialog("Tens a certeza que queres remover o grupo <b>"+item.name+"</b>?");
                eventBus.$on('onConfirmationDialog', () => {
                    this.removeItem(item);
                });
            },

            removeItem(item){
                this.axios.delete('group/'+ item.id,)
                    .then(response => {
                        this.consoleLog(response);
                        if (!response.data.success) {
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.fetchData();
                        this.showSnackBar('Grupo removido com sucesso', 'green');
                    })
                    .catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('ocorreu um erro. Por favor Tente novamente', 'red');
                    }).finally(()=>{
                    eventBus.$emit('onConfirmationDialogFinishLoading');
                });
            },
        },

        computed: {
            selectedPermission: {
                get(){
                    return this.$store.getters.getSelectedPermission;
                },
                set(value){
                    this.$store.dispatch('setSelectedPermission', value);
                }
            },
            showFormPermission: {
                get(){
                    return this.$store.getters.getShowFormPermission;
                },
                set(value){
                    this.$store.dispatch('setShowFormPermission', value);
                }
            },
            showFormPermissionViewMode: {
                get(){
                    return this.$store.getters.getShowFormPermissionViewMode;
                },
                set(value){
                    this.$store.dispatch('setShowFormPermissionViewMode', value);
                }
            },
        },
    }
</script>

<style scoped>

</style>